module.exports = __webpack_public_path__ + "files/ee3a1c8ce9d9ae2f5373fd4339b83be8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lato-regular.svg
 ** module id = 856
 ** module chunks = 0
 **/